// extracted by mini-css-extract-plugin
export default {"reasons":"style_reasons__exlaY","left":"style_left__sgRtB","right":"style_right__1J6bZ","details":"style_details__Llsw-","partners":"style_partners__g+jeX"};